import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';
import { mapMeetingFromApi } from './meetingsApi';

export async function fetchShareholderMeetings() {
  const res = await fetch(`${API_BASE}/api/shareholder/meetings`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الاجتماعات'));
  return (Array.isArray(data) ? data : []).map(mapMeetingFromApi);
}
